import type { AccountType } from './auth';

export function getEffectiveAccountType(
  accountType: AccountType,
  accountTypeEndDate: Date | null,
  previousAccountType: AccountType | null,
): AccountType {
  if (accountTypeEndDate && accountTypeEndDate < new Date()) {
    return previousAccountType ?? 'regular';
  }
  return accountType;
}

export function deriveRoleFromAccountType(at: AccountType): 'user' | 'premium' {
  return at === 'premium' ? 'premium' : 'user';
}

export function deriveIsBetaTesterFromAccountType(at: AccountType): boolean {
  return at === 'betaTester';
}

export interface User {
  id: string;
  email: string;
  displayName: string | null;
  createdAt: Date;
  lastLoginAt: Date | null;
  accountType: AccountType;
  accountTypeEndDate: Date | null;
  previousAccountType: AccountType | null;
  role: 'user' | 'premium';
  isAdmin: boolean;
  isBetaTester: boolean;
  isDeleted: boolean;
  /** When true, the user is a test account: excluded from Brevo sync, analytics, and production-side effects. */
  isForTests: boolean;
  deletedAt: Date | null;
  preferredInvestmentTypes: string[];
  settings: UserSettings;
  acceptedTosVersion: string | null;
  tosAcceptedAt: Date | null;
  metadata: Record<string, unknown>;
}

export type DateFormatOption = 'eu' | 'us';

export interface UserSettings {
  baseCurrency: string;
  dealCurrency: string;
  loanCurrency: string;
  emailNewsletter: boolean;
  paymentReminders: boolean;
  dateFormat: DateFormatOption;
  country: string;
}
